import { handleScrollToDiv } from "../components/navbar";

export function Soluctions({ texts }: any) {
  return (
    <section id="soluctions" className="bg-[#303133] lg:py-44 py-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          <div className="w-full lg:w-12/12 px-4 mb-8 lg:mb-0">
            <div className="text-center">
              <h5 className="text-lg text-[#e04f39] uppercase mb-4">
                {texts.title}
              </h5>
              <h1 className="text-6xl font-black mb-8 text-white">
                {texts.subtitle}{" "}
              </h1>
              {texts.description}
              <div className="my-20 flex flex-col lg:flex-row justify-between gap-6">
                {texts.data.map((item: any) => (
                  <div className="lg:w-1/2">
                    <h5 className="text-lg text-[#e04f39] uppercase mb-4">
                      {item.title}
                    </h5>
                    {item.content}
                  </div>
                ))}
              </div>
              <button
                className="bg-[#e04f39] hover:[#e68475] text-white font-normal py-5 px-10 rounded-full cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  handleScrollToDiv("contact");
                }}
              >
                {texts.button}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Soluctions;
